import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function TermsPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-2xl mx-auto px-6 py-16">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground mb-8"
        >
          <ArrowLeft className="h-4 w-4" />
          Back
        </button>

        <h1 className="font-heading text-3xl font-semibold text-foreground mb-8">
          Terms of Service
        </h1>

        <div className="space-y-6 text-muted-foreground">
          <p>
            By using Decisora, you agree to the following terms:
          </p>

          <div className="space-y-4">
            <div>
              <h3 className="text-foreground font-medium mb-2">Service Description</h3>
              <p className="text-sm">
                Decisora provides AI-assisted decision analysis for clarity and structured thinking. 
                It does NOT guarantee outcomes or provide professional advice.
              </p>
            </div>

            <div>
              <h3 className="text-foreground font-medium mb-2">User Responsibility</h3>
              <p className="text-sm">
                Users are fully responsible for their own decisions. Decisora is a thinking tool, 
                not a decision-maker.
              </p>
            </div>

            <div>
              <h3 className="text-foreground font-medium mb-2">Usage Limits</h3>
              <p className="text-sm">
                Usage limits may apply based on your plan (e.g., decisions per day). 
                These limits help ensure quality service for all users.
              </p>
            </div>

            <div>
              <h3 className="text-foreground font-medium mb-2">Prohibited Use</h3>
              <p className="text-sm">
                Misuse or abuse of the service is prohibited. This includes attempting to 
                circumvent limits or using the service for harmful purposes.
              </p>
            </div>

            <div>
              <h3 className="text-foreground font-medium mb-2">Changes to Service</h3>
              <p className="text-sm">
                Features and pricing may evolve over time. We will notify users of significant changes.
              </p>
            </div>
          </div>

          <p className="text-xs text-muted-foreground/70 pt-4">
            Last updated: February 2026
          </p>
        </div>
      </div>
    </div>
  );
}
